import apiService from "../../Services/APIService";
import { checkAPIResponse } from "../../Utils/APIResponseUtils";
import store from "../../Store/Store";
import { getUsersArr } from "../../Store/Reducers";

const buildTktPayload = (tktData, operation) => {
  const isDelete = operation === 'DELETE';

  return {
    changeType: isDelete ? 'DLT' : 'ADD',
    tktTypeID: tktData.typeID,
    notes: tktData.notes || '',
    link: (tktData.link || window.location.pathname).trim(),
    tktFile: tktData.tktFile || '',
    agencyEmail: tktData.agnecyEmail,
    agencyMobile: tktData.agencyMobile,
    countryCode: tktData.countryCode,
    agencyName: tktData.agencyName,
    adminUserName: tktData.adminUserName
  };
};

// Unified ticket management function
export const manageTktAPI = async (tktData, operation = 'ADD') => {
  const state = store.getState()
  try {
    const users = getUsersArr(state);
    const adminUser = users.find(user => user.IsAdmin === true);
    const adminUserName = adminUser ? adminUser.Name : state.agencyData.data.AgencyName;
    
    tktData = {
      ...tktData,
      agencyName: state.agencyData.data.AgencyName,
      agnecyEmail: state.masterData.ownEmail && state.masterData.ownEmail[0] ? state.masterData.ownEmail[0] : "",
      agencyMobile: state.agencyData.data.Mobile,
      countryCode: state.agencyData.data.CC,
      adminUserName: adminUserName
    }
    const payload = buildTktPayload(tktData, operation);
    const result = await apiService.sendChange(10, 'set', payload);
    checkAPIResponse(result);
    return result;
  } catch (error) {
    console.error(`${operation} ticket API error:`, error);
    throw error;
  }
};